import React from 'react';

const TicketCountBadge = ({ count, className }) => {
  if (!count) return null;
  return (
    <span className={className}>
      {count > 99 ? '99+' : count}
    </span>
  );
};

export default TicketCountBadge;
